(()=>{

/* ===== EDIT HERE ===== */
// Trustpilot review count. Leave null to hide the "Based on N reviews" text.
var REVIEW_COUNT = "2,008";

// One object per card. L+F Stamped and Trustpilot reviews from Codex testimonials.json (content/REVIEWS.md spares).
// Text only, initial avatars: no reviewer photo is on file. Headline = the review's own words.
var CARDS = [
  { name: "Robin R.", verified: false, title: "A Much Smoother Neck",
    bullets: ["Used on: face, neck"],
    quote: "Last month, 3 generations of my family took a trip to Ireland. When the pics came in, I started going through them which lead to going back to look at pics from our last visit there in 2019. I had not fully realized how my skin had rejuvenated since I started using MiamiMD two years ago! Noticeable reduction in facial lines and a much smoother neck!! I’m a customer for life and can’t wait to see continued improvement in the next set of “trip pics” (Italy this summer) 😃", thumbs: null, label: "robin-r" },
  { name: "Jean B.", verified: false, title: "It Took About 4 Months To Notice A Real Difference",
    bullets: ["Used on: marionette lines, frown lines"],
    quote: "I have been using the “Lift & Firm” cream for about 6 months, morning and night.. I am 71 years old, fair,dry skin. My desire was to reduce “marionette lines” and frown lines between my eye brows and forehead. It took about 4 months to notice a real difference. But now, the difference is clearly evident. Minimal lines!! When people ask my age, they don’t believe my answer!! I don’t look ANYTHING close to almost 72!! I get that reaction over and over!! Thank you so much for this incredible product!!", thumbs: null, label: "jean-b" },
  { name: "Priscilla B.", verified: false, title: "Made A Difference In The Wrinkles Above My Lips",
    bullets: ["Used on: lines above the lips"],
    quote: "This face cream has made a difference in the wrinkles above my lips! So far everything I have tried from MiamiMD has worked.", thumbs: null, label: "priscilla-b" },
  { name: "Gina S.", verified: false, title: "Makes Your Skin Feel Alive And So Soft",
    bullets: ["Used on: face, neck"],
    quote: "I’ve been using this amazing cream for almost 2 years and I love it! It goes on lighter than any cream I’ve ever used! Applying it on your face and neck makes your skin feel alive and so soft. For best results,I use every night after showering and/or every morning after showering and/or washing my face with warm water.", thumbs: null, label: "gina-s" },
  { name: "Karen H.", verified: false, title: "I Can See The Difference",
    bullets: [],
    quote: "I’ve been using Age Defying Lift and Firm Cream for at least 2 years. Didn’t think I needed it but I can see the difference. I’ll be 76 in July and most people guess me to be 65!", thumbs: null, label: "karen-h" }
];
CARDS = CARDS.filter(function(c){ return !document.querySelector('[data-acfq-r6-feat="' + c.label + '"]'); });
(function(){
  var STAR = '<svg viewBox="0 0 24 24"><path fill="#fff" d="M12 2.5l2.7 6.6 7.1.5-5.4 4.6 1.7 6.9L12 17.4l-6.1 3.7 1.7-6.9L2.2 9.6l7.1-.5z"/></svg>';
  var CHECK_WHITE = '<svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="10" fill="#fff"/><path d="M5.8 10.3l2.7 2.7 5.6-5.8" fill="none" stroke="#22b378" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CHECK_GREEN = '<svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="10" fill="#22b378"/><path d="M5.8 10.3l2.8 2.8 5.6-5.8" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var THUMB = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" stroke-linecap="round" d="M7 10v11H3V10h4zm0 0l4-7c1.5 0 2.5 1 2.5 2.5V9h6a2 2 0 0 1 2 2.3l-1.3 7.5a2 2 0 0 1-2 1.7H7"/></svg>';
  var DISCLAIMER = "Based on individual user experience. Results may vary.";

  // Trustpilot stars + count
  var stars = document.getElementById("tpStars"), s = "";
  for (var i = 0; i < 5; i++) s += '<span class="acfbpx-tp-star' + (i === 4 ? ' half' : '') + '">' + STAR + '</span>';
  if (stars) stars.innerHTML = s;
  if (stars && REVIEW_COUNT !== null && REVIEW_COUNT !== undefined) {
    document.getElementById("tpNum").textContent = typeof REVIEW_COUNT === "number" ? REVIEW_COUNT.toLocaleString("en-US") : REVIEW_COUNT;
    document.getElementById("tpCount").hidden = false;
  }

  function esc(t){ return String(t).replace(/[&<>"]/g, function(c){ return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]; }); }

  var track = document.getElementById("tfTrack");
  track.innerHTML = CARDS.map(function(c){
    var bullets = (c.bullets || []).map(function(b){ return "<li>" + CHECK_GREEN + "<span>" + b + "</span></li>"; }).join("");
    var note = c.verified ? '<span class="note">' + DISCLAIMER + '</span>' : '';
    var alt = "Before and after photo" + (c.verified ? " from " + c.name : ", illustrative");
    return '<article class="acfbpx-tf-card" data-label="' + esc(c.label || "") + '">' +
      '<div class="acfbpx-tf-who"><span class="acfbpx-tf-name">' + esc(c.name) + '</span>' +
        ('<span class="acfbpx-tf-pill">' + CHECK_WHITE + 'Review</span>') + '</div>' +
      (c.title ? '<p class="acfq-rv-title">' + esc(c.title) + '</p>' : '') +
      '<ul class="acfbpx-tf-bullets">' + bullets + '</ul>' +
      '<p class="acfbpx-tf-quote">“' + esc(c.quote) + '”</p>' +
      (false ? '<div class="acfbpx-tf-help">' + THUMB + '<span>' + Number(c.thumbs) + '</span></div>' : '') +
    '</article>';
  }).join("");

  // Missing image -> gray placeholder box
  Array.prototype.forEach.call(track.querySelectorAll(".acfbpx-tf-photo img"), function(img){
    img.addEventListener("error", function(){
      var ph = document.createElement("div");
      ph.className = "ph"; ph.textContent = "";
      img.replaceWith(ph);
    });
  });

  // Carousel
  var section = document.querySelector(".acfbpx-tf");
  var viewport = document.getElementById("tfViewport");
  var dotsEl = document.getElementById("tfDots");
  var prev = document.getElementById("tfPrev"), next = document.getElementById("tfNext");
  var idx = 0, per = 3, positions = 1;

  function perView(){ return parseInt(getComputedStyle(section).getPropertyValue("--per"), 10) || 1; }
  function step(){
    var card = track.children[0]; if (!card) return 0;
    var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    return card.getBoundingClientRect().width + gap;
  }
  function render(){
    track.style.transform = "translateX(" + (-idx * step()) + "px)";
    Array.prototype.forEach.call(dotsEl.children, function(d, i){
      d.classList.toggle("on", i === idx);
      d.setAttribute("aria-pressed", i === idx ? "true" : "false");
    });
  }
  function layout(){
    per = perView();
    positions = Math.max(1, CARDS.length - per + 1);
    idx = Math.min(idx, positions - 1);
    var h = "";
    for (var i = 0; i < positions; i++) h += '<button class="acfbpx-tf-dot" type="button"  aria-label="Go to position ' + (i + 1) + '"></button>';
    dotsEl.innerHTML = h;
    Array.prototype.forEach.call(dotsEl.children, function(d, i){ d.addEventListener("click", function(){ go(i); }); });
    render();
    var photo=track.querySelector('.acfbpx-tf-photo');if(photo)section.style.setProperty('--tf-arrow-y',(photo.getBoundingClientRect().top-section.getBoundingClientRect().top+photo.getBoundingClientRect().height/2)+'px');
  }
  function go(i,automatic){ if(!automatic)stopAuto(); idx = (i + positions) % positions; render(); } // arrows wrap around
  prev.addEventListener("click", function(){ go(idx - 1); });
  next.addEventListener("click", function(){ go(idx + 1); });

  // Swipe
  var timer=null,stopped=false,onScreen=false,hovered=false,motion=window.matchMedia('(prefers-reduced-motion: reduce)');
  try{stopped=sessionStorage.getItem('acfbp-tf-manual')==='1'}catch(e){}
  function cancelAuto(){clearTimeout(timer);timer=null;}
  function stopAuto(){stopped=true;section.dataset.autoStopped='true';cancelAuto();try{sessionStorage.setItem('acfbp-tf-manual','1')}catch(e){}}
  function scheduleAuto(){cancelAuto();if(stopped||!onScreen||hovered||document.hidden||motion.matches)return;timer=setTimeout(function(){go(idx+1,true);scheduleAuto()},6000);}
  section.addEventListener('focusin',stopAuto);section.addEventListener('mouseenter',function(){hovered=true;cancelAuto()});section.addEventListener('mouseleave',function(){hovered=false;scheduleAuto()});document.addEventListener('visibilitychange',scheduleAuto);motion.addEventListener('change',scheduleAuto);
  if(window.IntersectionObserver)new IntersectionObserver(function(entries){onScreen=entries[0].isIntersecting;scheduleAuto()},{threshold:.15}).observe(section);
  viewport.addEventListener('touchstart',stopAuto,{passive:true});
  var x0 = null, y0 = null, dx = 0, dragging = false;
  viewport.addEventListener("touchstart", function(e){ x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; dx = 0; dragging = false; }, {passive:true});
  viewport.addEventListener("touchmove", function(e){
    if (x0 === null) return;
    var mx = e.touches[0].clientX - x0, my = e.touches[0].clientY - y0;
    if (!dragging && Math.abs(mx) > 8 && Math.abs(mx) > Math.abs(my)) dragging = true;
    if (dragging){
      dx = mx;
      track.style.transition = "none";
      track.style.transform = "translateX(" + (-idx * step() + dx) + "px)";
    }
  }, {passive:true});
  viewport.addEventListener("touchend", function(){
    track.style.transition = "";
    if (dragging && Math.abs(dx) > 40 && !(dx > 0 && idx === 0) && !(dx < 0 && idx === positions - 1)) go(idx + (dx < 0 ? 1 : -1)); else render();
    x0 = null; dragging = false;
  });

  var rt; window.addEventListener("resize", function(){ clearTimeout(rt); rt = setTimeout(layout, 100); });
  layout();
})();

})();